import { Button, ConfigProvider } from "antd";
import { t } from "i18next";

/**
 * Excel dışa aktarım butonu — TEK standart.
 *
 * Eskiden her ekran kendi çözümünü kuruyordu: `type="success"` (antd v5'te böyle bir tip yok,
 * default'a düşüp kart zeminiyle aynı görünüyordu) ya da var olmayan `bg-success` sınıfı +
 * yalnız ikon. İkisi de zeminde kayboluyordu.
 *
 * Yeşil, yazılı, dolu bir buton. Renk nested ConfigProvider ile colorPrimary'ye bağlandı;
 * hover/active/disabled tonlarını antd kendisi türetiyor (dış temanın compact algoritması
 * miras alınır).
 */
const EXCEL_GREEN = '#217346';

export default function ExcelButton({ children, ...props }) {
    return (
        <ConfigProvider theme={{ token: { colorPrimary: EXCEL_GREEN } }}>
            <Button type={'primary'} {...props}>
                {children ?? t('Excel')}
            </Button>
        </ConfigProvider>
    )
}
